import { Component, OnInit } from '@angular/core';
import { AppInfo } from '../appInfo.model';
import { InfoService } from '../info.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {

	show = false;
	autohide = true;
  info: AppInfo;

  constructor(
    private infoService: InfoService
  ) { 
  }

  ngOnInit(): void {
    this.infoService.getSubjectToast().subscribe(info => {
        this.showInfo(info);
    });
  }

  showInfo(info: AppInfo): void {
    this.info = info;
    this.show = true;
  }

  hideEvent():void {
    this.show = false;
    this.autohide = true
  }

}
